import type { Ref } from 'vue';
import { HttpMethods, RequestPerformer } from '@/api/api-requests-factory';
import GetPspTagListRequest from '@/api/psp-tag/get-psp-tag-list.request';
import GetPspTagRequest from '@/api/psp-tag/get-psp-tag.request';
import CreatePspTagRequest from '@/api/psp-tag/create-psp-tag.request';
import UpdatePspTagRequest from '@/api/psp-tag/update-psp-tag.request';
import DeletePspTagRequest from '@/api/psp-tag/delete-psp-tag.request';

export class PspTagApiResources {
  constructor(
    private readonly requestPerformer: RequestPerformer,
    private readonly multibrandApiHost: Ref<string>,
  ) { }

  public get getPspTagListRequest(): GetPspTagListRequest {
    return new GetPspTagListRequest(
      this.requestPerformer,
      `${this.multibrandApiHost.value}/api/v1.0/front/paymentTag`,
      HttpMethods.GET,
    );
  }

  public get getPspTagRequest(): GetPspTagRequest {
    return new GetPspTagRequest(
      this.requestPerformer,
      `${this.multibrandApiHost.value}/api/v1.0/front/paymentTag`,
      HttpMethods.GET,
    );
  }

  public get createPspTagRequest(): CreatePspTagRequest {
    return new CreatePspTagRequest(
      this.requestPerformer,
      `${this.multibrandApiHost.value}/api/v1.0/front/paymentTag`,
      HttpMethods.POST,
    );
  }

  public get updatePspTagRequest(): UpdatePspTagRequest {
    return new UpdatePspTagRequest(
      this.requestPerformer,
      `${this.multibrandApiHost.value}/api/v1.0/front/paymentTag`,
      HttpMethods.PUT,
    );
  }

  public get deletePspTagRequest(): DeletePspTagRequest {
    return new DeletePspTagRequest(
      this.requestPerformer,
      `${this.multibrandApiHost.value}/api/v1.0/front/paymentTag`,
      HttpMethods.DELETE,
    );
  }
}
